import { useContext } from 'react'

import { PassContext } from './pass-context'

const normaliseUrl = url => typeof url === "string" && url.length ? url : null

const withCorsVariant = (url, cacheKey) => {
  if (!url) return url

  try {
    const parsed = new URL(url, window.location.href)
    parsed.searchParams.set("_cors", "1")
    if (cacheKey) parsed.searchParams.set("_smartix_cors", String(cacheKey))
    return parsed.toString()
  }
  catch {
    const separator = url.includes("?") ? "&" : "?"
    return `${url}${separator}_cors=1${cacheKey ? `&_smartix_cors=${encodeURIComponent(cacheKey)}` : ""}`
  }
}

const PassImage = ({
  src,
  className,
  style,
  alt = "",
  onLoad,
  crossOrigin,
  ...rest
}) => {
  const { allowImageCors = false, imageCorsKey = 0 } = useContext(PassContext)
  const resolvedSrc = normaliseUrl(src)
  if (!resolvedSrc) return null
  const resolvedCrossOrigin = crossOrigin ?? (allowImageCors ? "anonymous" : null)
  const renderSrc = allowImageCors ? withCorsVariant(resolvedSrc, imageCorsKey) : resolvedSrc

  return (
    <img
      key={`${renderSrc}|${resolvedCrossOrigin ?? "none"}`}
      src={renderSrc}
      crossOrigin={resolvedCrossOrigin}
      className={className}
      style={style}
      alt={alt}
      onLoad={onLoad}
      {...rest}
    />
  )
}

const PassBackgroundImage = ({
  src,
  className,
  style,
  children,
  ...rest
}) => {
  const { allowImageCors = false, imageCorsKey = 0 } = useContext(PassContext)
  const resolvedSrc = normaliseUrl(src)
  const renderSrc = allowImageCors ? withCorsVariant(resolvedSrc, imageCorsKey) : resolvedSrc

  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: renderSrc ? `url(${renderSrc})` : "none",
      }}
      {...rest}
    >
      {children}
    </div>
  )
}

export {
  PassImage,
  PassBackgroundImage,
}
